// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3_-UK","paper":"styles_paper__71z8d","tabName":"styles_tabName__3jJ8m"};